import Vue from 'vue';
import VueRouter from 'vue-router';
import VueGtag from 'vue-gtag';
import routes from 'routes';
import { changeTitlePageWithRoute } from 'helpers/page';
import store from 'store';
import { i18n } from '@/setup/i18n';
import { GET_APP_COMMON_DATA } from 'store/actions/website';
import { UI_SET_LOADER } from 'store/actions/ui';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  hashbang: false,
  root: '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes
});

// Trackings
const googleAnalyticsId = process.env.GOOGLE_ANALYTICS_ID;
if (process.env.NODE_ENV === 'production') {
  if (googleAnalyticsId)
    Vue.use(
      VueGtag,
      {
        config: { id: googleAnalyticsId }
      },
      router
    );
}

// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

router.beforeEach((to, from, next) => {
  changeTitlePageWithRoute(to.meta);

  if (['error', '404'].indexOf(to.name) > -1) return next();

  return store
    .dispatch(`website/${GET_APP_COMMON_DATA}`, i18n().locale)
    .then(() => next())
    .catch(() => {
      // Redirect to the error page
      redirectToErrorPage(next, GET_APP_COMMON_DATA);
    });
});

// After navigation is confirmed, but before resolving...
router.beforeResolve((to, from, next) => {
  // Hide the loading component from startup
  store.dispatch(`ui/${UI_SET_LOADER}`, false);
  next();
});

export { router as default };
